export const RECONNECT_REFETCH_MIN_GAP_MS = 60_000

type CancelTimer = () => void

const scheduleTimeout = (run: () => void, delayMs: number): CancelTimer => {
    const timer = setTimeout(run, delayMs)
    return () => clearTimeout(timer)
}

export function createReconnectRefetchScheduler({
    refetch,
    minGapMs = RECONNECT_REFETCH_MIN_GAP_MS,
    now = () => Date.now(),
    schedule = scheduleTimeout,
}: {
    refetch: () => void
    minGapMs?: number
    now?: () => number
    schedule?: (run: () => void, delayMs: number) => CancelTimer
}): { onReconnect: () => void; dispose: () => void } {
    let lastRefetchAt: number | null = null
    let cancelTrailing: CancelTimer | null = null

    const runRefetch = () => {
        cancelTrailing = null
        lastRefetchAt = now()
        refetch()
    }

    return {
        onReconnect: () => {
            const at = now()
            if (lastRefetchAt === null || at - lastRefetchAt >= minGapMs) {
                cancelTrailing?.()
                runRefetch()
                return
            }
            if (cancelTrailing) return
            cancelTrailing = schedule(runRefetch, lastRefetchAt + minGapMs - at)
        },
        dispose: () => {
            cancelTrailing?.()
            cancelTrailing = null
        },
    }
}
